import React from 'react'

import {
  COMPONENTS_EDITOR_MAP,
  COMPONENTS_PREVIEW_MAP
} from 'shared/enums/index'

import Sidebar from 'components/Sidebar'
import SidebarContent from 'components/SidebarContent'
import SidebarHeadline from 'components/SidebarHeadline'
import SidebarClose from 'components/SidebarClose'

export default props => (
  <Sidebar anchor="right" isOpen={props.isOpen}>
    <SidebarClose onClose={props.onClose} />

    {props.pageComponent &&
      <React.Fragment>
        <SidebarContent>
          <SidebarHeadline>{props.pageComponent.component.name}</SidebarHeadline>

          {(() => {
            const ComponentEditor = COMPONENTS_EDITOR_MAP[props.pageComponent.component.type]
            const previewAttrs = COMPONENTS_PREVIEW_MAP[props.pageComponent.component.type]

            const attrs = {
              ...previewAttrs,
              ...props.pageComponent.attrs
            }

            return (
              <ComponentEditor
                attrs={attrs}
                onAttributeChange={props.onAttributeChange}
              />
            )
          })()}
        </SidebarContent>
      </React.Fragment>
    }
  </Sidebar>
)



// WEBPACK FOOTER //
// ./src/components/ComponentEditor/index.js